'use client'
import localFont from "next/font/local";
import { Poppins } from 'next/font/google'
import "./globals.css";
import { getThemeClassName, applyUniversityTheme } from "@/lib/theme";
import { useEffect } from "react";

const geistSans = localFont({
  src: "./fonts/GeistVF.woff",
  variable: "--font-geist-sans",
  weight: "100 900",
});
const geistMono = localFont({
  src: "./fonts/GeistMonoVF.woff",
  variable: "--font-geist-mono",
  weight: "100 900",
});
const poppins = Poppins({
  subsets: ['latin'],
  weight: ['100', '300', '400', '500', '700', '900'],
  variable: "--font-poppins"
})

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  // Get the theme class for SSR
  const themeClass = getThemeClassName();

  useEffect(() => {
    // Apply theme on client side
    applyUniversityTheme();
  }, []);

  return (
    <html lang="en" className={themeClass}>
    <head>
      <script defer src="https://cloud.umami.is/script.js" data-website-id="7a35bdb9-0fcd-4fe1-b3b2-ae0a72059574"></script>
      <script async src="https://cdn.userway.org/widget.js" data-account="qZUpuP1tbw"></script>
      <title>{process.env.NEXT_PUBLIC_UNIVERSITY_NAME + ' x Optimum Student Support | Apprenticeship Learning Support'}</title>
    </head>
    <body
        className={`${poppins.variable} ${geistSans.variable} ${geistMono.variable} antialiased bg-background`}
      >
        {children}
      </body>
    </html>
  );
}
